export const GET_COACHES = "GET_COACHES";
export const RESET_COACHES = "RESET_COACHES";
export const SET_COACHES_REQUEST_STATUS = "SET_COACHES_REQUEST_STATUS";
